import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["locationGroupSelect", "locationSelect"];
  static outlets = ["multiselect"];

  static values = {
    locationsByLocationGroup: String,
  };

  connect() {
    // Initialize location filtering
    if (this.hasLocationsByLocationGroupValue) {
      this.locationsByLocationGroup = JSON.parse(this.locationsByLocationGroupValue);
    }
  }

  updateLocations(event) {
    const locationGroupId = event.target.value;

    const locations = locationGroupId
      ? this.locationsByLocationGroup[locationGroupId] || []
      : Object.values(this.locationsByLocationGroup);

    const options = locations
      .flat()
      .map((location) => ({
        label: location.name,
        value: location.id.toString(),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    this.setMultiselectOptions(options, !locationGroupId);
  }

  disableElement(element) {
    element.disabled = true;
  }

  enableElement(element) {
    element.disabled = false;
  }

  setMultiselectOptions(options, preserveSelections = false) {
    this.multiselectOutlet.setOptions(options, preserveSelections);
  }
}
